import { ButtonV2 } from '@payfit/growth-platform-brand-system-v2';
import { ButtonTracking } from '@payfit/growth-platform-brand-system-v2/utils/tracking/ButtonTracking';
import { LabelsPricingPageRecord } from 'apps/website/types/dato';
import { Link } from 'gatsby';
import React from 'react';

const Button = ({
  link,
  linkOnDemand,
  onDemandTitle,
  index,
  labels,
}: {
  link?: string;
  linkOnDemand?: string;
  onDemandTitle?: boolean;
  index: number;
  labels?: LabelsPricingPageRecord;
}) => {
  const title = onDemandTitle
    ? labels?.onDemandButtonLabel
    : labels?.buttonLabel;
  const linkTo = onDemandTitle ? linkOnDemand : link;

  return (
    <div className="flex flex-col gap-[8px]">
      {linkTo?.startsWith('/') && (
        <ButtonTracking
          component={ButtonV2}
          as={Link}
          variant={index === 1 ? 'primary' : 'secondary'}
          title={title}
          to={linkTo}
        />
      )}
      {linkTo?.startsWith('http') && (
        <ButtonTracking
          component={ButtonV2}
          as={'a'}
          variant={index === 1 ? 'primary' : 'secondary'}
          title={title}
          href={linkTo}
        />
      )}
      {labels?.underButtonLabel && (
        <div className="text-[#55687D]">{labels?.underButtonLabel}</div>
      )}
    </div>
  );
};

export default Button;
